const loadAsyncJS = require('../../../src/frontend/helper/general/m_loadAsyncJS');
const { escape } = require('../../../src/frontend/helper/underscore/escape');

module.exports = (function() {
  const h = document.head;

  const dfp = function(data) {
    // Check data integrity
    const placements = data.adPlacements;
    if (!Array.isArray(placements)) {
      throw "Response doesn't have valid placements";
    }

    // Helper methods
    const read = function(s) {
      s = escape(s);
      try {
        s = JSON.parse(s);
      } catch (ignored) {}
      return s;
    };
    const getAttrs = function(metaData, type) {
      if (metaData.name !== type) {
        return {};
      }
      const names = [];
      for (let i = 2, len = arguments.length; i < len; i++) {
        names.push(arguments[i]);
      }
      return names.reduce((collection, name) => {
        collection[name] = read(metaData.getAttribute(`data-${name}`));
        return collection;
      }, {});
    };
    // Parse data
    const metatags = Array.from(h.getElementsByTagName('meta'));
    const configs = metatags.reduce((collection, meta) => {
      if ((data = getAttrs(meta, 'ai-dfp-target', 'key', 'val'))) {
        collection[data.key] = data.val;
      }
      return collection;
    }, {});

    window.googletag.cmd.unshift(() => {
      placements.forEach(placement => {
        if (placement.adType === 'external' && placement.adFormat === 'dfp') {
          const dfpContent = placement.dfpContent;
          window.googletag
            .defineSlot(dfpContent.adTarget, dfpContent.adSizes, dfpContent.id)
            .addService(window.googletag.pubads());
          Object.assign(configs, dfpContent.configs);
        }
      });
      for (const k in configs) {
        if (!configs.hasOwnProperty(k)) {
          continue;
        }
        window.googletag.pubads().setTargeting(k, configs[k]);
      }
      window.googletag.pubads().enableSingleRequest();
      window.googletag.pubads().collapseEmptyDivs();
      window.googletag.enableServices();
    });
    placements.forEach(placement => {
      window.googletag.cmd.push(() => {
        window.googletag.display(placement.dfpContent.id);
      });
    });
    // Load GPT tag
    loadAsyncJS('//www.googletagservices.com/tag/js/gpt.js');
  };

  return {
    init() {
      if (!document.head.querySelector("meta[name='ai-dfp-manual']")) {
        Groupon.DFPAds.load();
      }
    },

    load() {
      if (!Groupon.DFPAds.isValidConsentCookie()) return;

      if (!h.querySelector("meta[name='ai-slot']")) {
        return;
      }
      const baseURLMeta = h.querySelector("meta[name='ai-base-url']");
      const baseURL = baseURLMeta
        ? baseURLMeta.getAttribute('data-base-url')
        : 'https://ai.groupondata.com/ai/api/v1/placement';
      const slotsMeta = h.querySelectorAll("meta[name='ai-slot']");
      const slots = [];
      const appNameMeta = h.querySelector("meta[name='ai-app-name']");
      const appName = appNameMeta
        ? appNameMeta.getAttribute('data-app-name')
        : '';
      const divisionMeta = h.querySelector("meta[name='ai-division']");
      const division = divisionMeta
        ? divisionMeta.getAttribute('data-division')
        : '';
      Array.prototype.forEach.call(slotsMeta, item => {
        slots.push(item.getAttribute('data-apif'));
      });
      const params = {
        app: appName,
        c_cookie: Cookie.get('c'),
        b_cookie: Cookie.get('b'),
        country: h.getAttribute('data-country'),
        locale: h.getAttribute('data-locale'),
        division,
        page: encodeURIComponent(location.href),
        platform: document.body.classList.contains('is-web') ? 'web' : 'touch',
        placements: slots.join('_'),
      };
      const urlSearchParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        const value = params[key];
        if (value) {
          try {
            urlSearchParams.append(key, value);
          } catch (ignored) {}
        }
      });

      fetch(`${baseURL}?${urlSearchParams.toString()}`)
        .then(res => {
          if (!res.ok) {
            throw "Response doesn't have status code 200";
          }
          return res.json();
        })
        .then(data => {
          dfp(data);
        })
        .catch(() => {});
    },
  };
})();
